import DetailTemplate from '@/components/detail-template'
import React, { useEffect, useMemo, useState } from 'react'
import { displayModel } from './display-model'
import {
  useAddReport,
  useDeleteList,
  useDeleteOfflineLogImportRecord,
  useGetAttackType,
  useGetAttck,
  useGetComponent,
  useGetComponents,
  useGetDecodeRate,
  useGetDeviceAlarm,
  useGetDevices,
  useGetEncodeRate,
  useGetExecuteTime,
  useGetExecuteType,
  useGetFailPayloadLog,
  useGetFailRate,
  useGetOfflineLogImportInfo,
  useGetPayloadList,
  useGetProgress,
  useGetProgressList,
  useGetProgressPayloadLog,
  useGetProtectRate,
  useGetRiskRate,
  useGetSerial,
  useGetTagTreeOptions,
  useGetTaskInfo,
  useGetTaskScore,
  useGetTemplateFailRate,
  useGetTemplateList,
  useUpdateInterceptStatus,
  useGetRequest,
  useGetLog,
  useGetFailedCaseList,
  useGetUnsentCaseList,
  useGetTaskResultLog,
  useGetVerifyResult,
  useGetAttackProtectionRanking,
  useGetRiskLevelDistribution,
  useGetDeviceProtectionRanking,
  useGetTemplateProtectionFailureRanking,
  useGetCaseLevelDistribution,
  useGetResourceFilterData,
} from './utils'
import styled from 'styled-components'
import {
  Button,
  Checkbox,
  Divider,
  Empty,
  Form,
  Image,
  Progress,
  Select,
  Tabs,
  Typography,
  Tooltip,
  Space,
} from 'antd'
import {
  DeleteModal,
  IconFont,
  ImportModal,
  RecordModal,
  SvgIcon,
  TagSearchOption,
  BasTitle,
} from '@/components'
import { CheckOutlined } from '@ant-design/icons'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import ProgressInfo, { ProgressItem } from '@/components/detail-template/widgets/progress-info'
import FailedTabs from '@/components/detail-template/widgets/failed-tabs'
import { OptionType } from '@/components/detail-template/widgets/search-panel'
import leakSeverity from '@/assets/imges/leak-severity.png'
import leakCenter from '@/assets/imges/leak-center.png'
import leakLow from '@/assets/imges/leak-low.png'
import leakHigh from '@/assets/imges/leak-high.png'
import TaskCharts from './task-charts'
import { DetailDrawer } from './detail-drawer'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { CreateReport } from '@/components/create-report'
import ProgressContent from '@/components/detail-template/widgets/progress-content'
import { FilterDropdownProps } from 'antd/lib/table/interface'
import { formatTimeInterval } from '@/utils'
import { t } from '@/i18n'
const { Text } = Typography
const { useForm } = Form
const { Item } = Form
const { Group } = Checkbox

const Detail: React.FC = () => {
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const navigate = useNavigate()
  const [form] = useForm()
  // 获取任务信息
  const [taskInfo, getTaskInfo] = useGetTaskInfo()
  // 获取进度信息
  const [progressInfo, getProgressInfo] = useGetProgress()
  // 获取执行时间
  const [executeTime, getExecuteTime] = useGetExecuteTime()
  // 获取执行类型
  const [executeType, getExecuteType] = useGetExecuteType()
  // 获取任务模板
  const [templateList, getTemplateList] = useGetTemplateList()
  // 获取影响组件
  const [components, getComponents] = useGetComponents()
  // 获取安全设备
  const [devices, getDevices] = useGetDevices()
  // 获取序列号
  const [serial, getSerial] = useGetSerial()
  // 获取进度信息列表
  const [progressList, getProgressList] = useGetProgressList()
  // 获取 payload 日志
  const [getProgressPayloadLog] = useGetProgressPayloadLog()
  // 获取执行失败用例列表
  const [failedCaseList, getFailedCaseList] = useGetFailedCaseList()
  // 获取未执行用例列表
  const [unsentCaseList, getUnsentCaseList] = useGetUnsentCaseList()
  // 获取任务结果日志
  const [taskResultLog, getTaskResultLog] = useGetTaskResultLog()
  // 进度内容列表
  const [progressContentList, setProgressContentList] = useState<any[]>([])
  // 获取 发送失败 payload 日志
  const [getFailPayloadLog] = useGetFailPayloadLog()
  // 获取攻击类型
  const [attackType, getAttackType] = useGetAttackType()
  // 获取 ATT&CK
  const [attckList, getAttck] = useGetAttck()
  // 用例分级筛选
  const [resourceFilterData, getResourceFilterData] = useGetResourceFilterData()
  // 获取payload列表
  const [getPayloadList, loading] = useGetPayloadList()
  // 修改拦截状态
  const [updateResourceInterceptStatus, updateInterceptStatusLoading] = useUpdateInterceptStatus()
  // 获取标签组列表
  const [getTagTreeOptions, tagTreeOptions] = useGetTagTreeOptions()
  // 获取任务评分 （图表）
  const [taskScore, getTaskScore] = useGetTaskScore()
  // 获取拦截结果（图表）
  // const [failRate, getFailRate] = useGetFailRate()
  // 获取验证结果
  const [verifyResult, getVerifyResult] = useGetVerifyResult()
  // 获取解码失败率 (图表)
  const [decodeRate, getDecodeRate] = useGetDecodeRate()
  // 获取设备防护能力排名
  const [deviceProtectionRanking, getDeviceProtectionRanking] = useGetDeviceProtectionRanking()
  // 获取模板防护失效排名
  const [templateProtectionFailureRanking, getTemplateProtectionFailureRanking] =
    useGetTemplateProtectionFailureRanking()

  // 攻击防护排名（图表轮播）
  const [attackProtectionRanking, getAttackProtectionRanking] = useGetAttackProtectionRanking()
  // 获取解码能力排名（轮播）
  const [encodeRate, getEncodeRate] = useGetEncodeRate()
  // 获取危险等级分布 (图表)
  const [riskLevelDistribution, getRiskLevelDistribution] = useGetRiskLevelDistribution()
  // 获取用例等级分布 (图表)
  const [caseLevelDistribution, getCaseLevelDistribution] = useGetCaseLevelDistribution()
  // 获取离线日志导入信息
  const [importRecord, getOfflineLogInfo] = useGetOfflineLogImportInfo()
  // 删除日志设备导入记录
  const [deleteOfflineLogInfo, deleteRecordLoading] = useDeleteOfflineLogImportRecord()
  // 生成报表
  const [generateReport, createLoading] = useAddReport()
  // 删除任务
  const [deleteTask] = useDeleteList()
  // 任务详情抽屉
  const [dataList, getPayloadDetail, detailLoading] = useGetRequest()
  // 获取任务结果日志
  const [logList, getLogList] = useGetLog()
  const { taskInfoExpanded, taskInfo: taskInfoModel } = displayModel

  const [timeId, setTimeId] = useState('')
  // 控制 payload日志 显隐
  const [logInfo, setLogInfo] = useState<{ visible: boolean; content: string; id: string }>({
    visible: false,
    content: '',
    id: '',
  })
  // 控制 发送失败payload日志 显隐
  const [failLogInfo, setFailLogInfo] = useState<{ visible: boolean; content: [] }>({
    visible: false,
    content: [],
  })
  // 筛选条件
  const [filterParams, setFilterParams] = useState({
    page: 1,
    limit: 20,
  })
  // 筛选框
  const [filterFormValue, setFilterFormValue] = useState<{
    field: string | number
    value: string | number | string[] | number[] | undefined
  }>({
    field: '',
    value: '',
  })
  // payload列表
  const [payloadList, setPayloadList] = useState<any[]>([])
  // payload总数
  const [payloadTotal, setPayloadTotal] = useState(0)
  // 修正payload数量
  const [fixPayloadCount, setFixPayloadCount] = useState(0)
  // 选中项的 key 数组
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([])
  // 触发进度信息刷新数据
  const [random, setRandom] = useState(0)
  // 控制 卡片 高亮
  const [cardActive, setCardActive] = useState('')
  // 编码Payload
  const [encode, setEncode] = useState(2)
  // 导入记录弹窗 visible
  const [recordVisible, setRecordVisible] = useState(false)
  // 导入离线日志弹窗 visible
  const [importVisible, setImportVisible] = useState(false)
  // 生成报表弹窗 visible
  const [reportVisible, setReportVisible] = useState({
    visible: false,
    result_id: id,
    name: taskInfo.task_name,
  })
  // 删除弹窗 visible
  const [deleteVisible, setDeleteVisible] = useState(false)
  // 控制 详情抽屉 显隐
  const [detailDrawerVisible, setDetailDrawerVisible] = useState(false)

  // 批量修正弹窗
  const [fixedModalVisible, setFixedModalVisible] = useState(false)

  const [activeTab, setActiveTab] = useState('failed')
  const [infoActiveTab, setInfoActiveTab] = useState('taskTemplate')

  const [updateAttackType, setUpdateAttackType] = useState(false)
  const [attackTypeSelectOpen, setAttackTypeSelectOpen] = useState(false)
  const [deviceStatusSelectOpen, setDeviceStatusSelectOpen] = useState(false)
  const [riskLevelSelectOpen, setRiskLevelSelectOpen] = useState(false)
  const [resourceLevelSelectOpen, setResourceLevelSelectOpen] = useState(false)
  const [interceptStatusSelectOpen, setInterceptStatusSelectOpen] = useState(false)

  const riskLevelMap = {
    0: { label: t('低危'), class: 'leak-low', icon: <Image src={leakLow} width={19} /> },
    1: { label: t('中危'), class: 'leak-center', icon: <Image src={leakCenter} width={19} /> },
    2: { label: t('高危'), class: 'leak-high', icon: <Image src={leakHigh} width={19} /> },
    3: { label: t('严重'), class: 'leak-severity', icon: <Image src={leakSeverity} width={19} /> },
  }

  const interceptStatusMap = {
    拦截成功: 'intercept-success',
    检测成功: 'detection-success',
    防护失效: 'intercept-fail',
  }

  const resourceLevelMap = {
    ResourceLevelJunior: { label: t('初级'), class: 'case-level-low' },
    ResourceLevelMiddle: { label: t('中级'), class: 'case-level-center' },
    ResourceLevelSenior: { label: t('高级'), class: 'case-level-high' },
  }

  const logAlarmMap = {
    1: { label: t('有告警'), class: 'log-alarm-success' },
    2: { label: t('无告警'), class: 'log-alarm-fail' },
  }

  const enctypeTypeMap = {
    动态载荷: 'dynamic-encoding',
    静态载荷: 'static-encoding',
  }

  const tagTreeData = useMemo(() => {
    const listMappings = [
      {
        title: t('用例分级'),
        list: resourceFilterData?.caseLevelList || [],
        total: resourceFilterData?.caseLevelTotal || 0,
        key: 'tree_resource_level',
      },
      {
        title: t('危险等级'),
        list: resourceFilterData?.riskLevelList || [],
        total: resourceFilterData?.riskLevelTotal || 0,
        key: 'tree_risk_level',
      },
      {
        title: t('验证结果'),
        list: resourceFilterData?.resourceStatusList || [],
        total: resourceFilterData?.resourceStatusTotal || 0,
        key: 'tree_intercept_status',
      },
      {
        title: t('安全设备'),
        list: resourceFilterData?.deviceList || [],
        total: resourceFilterData?.deviceTotal || 0,
        key: 'tree_device_ids',
      },
    ]

    return listMappings.map(category => ({
      title: category.title,
      key: category.key,
      extra: category.total,
      children: category.list.map(item => ({
        title: item.fieldName,
        key: `${category.key}_${item.fieldId}`,
        extra: item.resourceCount,
      })),
    }))
  }, [resourceFilterData])

  const options = [
    {
      label: t('用例名称'),
      value: 'name',
      type: 'input' as const,
    },
    {
      label: t('影响组件'),
      value: 'component',
      type: 'select',
      options: components.map(item => ({
        label: item.name,
        value: item.name,
      })),
    },
    {
      label: 'ATT&CK',
      value: 'attck_name_list',
      type: 'select',
      mode: 'multiple',
      options: attckList?.map(item => ({
        label: item.name,
        value: item.name,
      })),
    },
    {
      label: t('用例标签'),
      value: 'tag_ids',
      type: 'treeSelect',
      mode: 'multiple',
      options: TagSearchOption(tagTreeOptions),
    },
    {
      label: t('模板名称'),
      value: 'template_id',
      type: 'select',
      mode: 'multiple',
      options: [...templateList.map(item => ({ label: item.name, value: item.id }))],
    },
    {
      label: t('载荷类型'),
      value: 'enctype',
      type: 'select',
      options: [
        { label: t('动态载荷'), value: 2 },
        { label: t('静态载荷'), value: 1 },
      ],
    },
  ]

  let columns = [
    {
      title: t('用例名称'),
      dataIndex: 'name',
      key: 'name',
      width: '30%',
      render: (text: string, record: any) => (
        <Text
          ellipsis={{
            tooltip: {
              getPopupContainer: () => document.body,
            },
          }}
          className="case_name"
          style={{ width: 300, cursor: 'pointer' }}
          onClick={() => {
            getDrawerData(record.id)
          }}
        >
          {record.name}
        </Text>
      ),
    },
    {
      title: t('危险等级'),
      dataIndex: 'risk_level',
      key: 'risk_level',
      width: '7%',
      filteredValue: filterParams.risk_level,
      render: (text: number) => (
        <div>
          {riskLevelMap[text - 1].icon}
          <span className={riskLevelMap[text - 1].class}>{riskLevelMap[text - 1].label}</span>
        </div>
      ),

      filterDropdown: (props: FilterDropdownProps) => (
        <div style={{ padding: 8, width: 300 }}>
          <Select
            mode="multiple"
            allowClear
            maxTagCount={'responsive'}
            style={{ width: '100%' }}
            placeholder={t('请选择危险等级')}
            value={props.selectedKeys as string[]}
            open={riskLevelSelectOpen}
            getPopupContainer={() => document.body as HTMLElement}
            dropdownClassName="table-filter-dropdown"
            onDropdownVisibleChange={setRiskLevelSelectOpen}
            onChange={value => {
              props.setSelectedKeys(value)
            }}
            dropdownRender={menu => (
              <div style={{ marginBottom: '6px' }}>
                {menu}
                <Divider style={{ margin: '3px 0 6px 0' }} />
                <Space
                  className="space-btn"
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  <Button
                    type="default"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.clearFilters?.()
                    }}
                  >
                    {t('重置')}
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.confirm()
                      setRiskLevelSelectOpen(false)
                    }}
                  >
                    {t('确定')}
                  </Button>
                </Space>
              </div>
            )}
            options={[
              { label: t('严重'), value: 4 },
              { label: t('高危'), value: 3 },
              { label: t('中危'), value: 2 },
              { label: t('低危'), value: 1 },
            ]}
          />
        </div>
      ),

      filterIcon: (filtered: boolean) => (
        <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
          <FilterIcon type="icon-a-shaixuan1" $filtered={filtered} />
        </Tooltip>
      ),
    },
    {
      title: t('攻击类型'),
      dataIndex: 'attack_type_name',
      key: 'attack_type_name',
      width: '10%',
      filteredValue: filterParams.attack_type_name,
      filterDropdown: (props: FilterDropdownProps) => (
        <div style={{ padding: 8, width: 300 }}>
          <Select
            allowClear
            mode="multiple"
            maxTagCount={'responsive'}
            style={{ width: '100%' }}
            placeholder={t('请选择攻击类型')}
            value={props.selectedKeys as string[]}
            open={attackTypeSelectOpen}
            getPopupContainer={() => document.body as HTMLElement}
            dropdownClassName="table-filter-dropdown"
            onDropdownVisibleChange={setAttackTypeSelectOpen}
            onChange={value => {
              props.setSelectedKeys(value)
            }}
            dropdownRender={menu => (
              <div style={{ marginBottom: '6px' }}>
                {menu}
                <Divider style={{ margin: '3px 0 6px 0' }} />
                <Space
                  className="space-btn"
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  <Button
                    type="default"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.clearFilters?.()
                    }}
                  >
                    {t('重置')}
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.confirm()
                      setAttackTypeSelectOpen(false)
                    }}
                  >
                    {t('确定')}
                  </Button>
                </Space>
              </div>
            )}
            options={attackType.map(item => ({ label: item, value: item }))}
          />
        </div>
      ),

      filterIcon: (filtered: boolean) => (
        <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
          <FilterIcon type="icon-a-shaixuan1" $filtered={filtered} />
        </Tooltip>
      ),

      render: (_, record: any) => (
        <Text
          ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
          style={{ width: 140 }}
        >
          {record?.attack_type}
        </Text>
      ),
    },
    {
      title: t('用例分级'),
      dataIndex: 'resource_level',
      key: 'resource_level',
      width: '7%',
      render: (text: number) => (
        <div>
          <span>{resourceLevelMap[text]?.label || '-'}</span>
        </div>
      ),

      filteredValue: filterParams.resource_level,
      filterDropdown: (props: FilterDropdownProps) => (
        <div style={{ padding: 8, width: 300 }}>
          <Select
            mode="multiple"
            allowClear
            maxTagCount={'responsive'}
            style={{ width: '100%' }}
            placeholder={t('请选择用例分级')}
            value={props.selectedKeys as string[]}
            open={resourceLevelSelectOpen}
            getPopupContainer={() => document.body as HTMLElement}
            dropdownClassName="table-filter-dropdown"
            onDropdownVisibleChange={setResourceLevelSelectOpen}
            onChange={value => {
              props.setSelectedKeys(value)
            }}
            dropdownRender={menu => (
              <div style={{ marginBottom: '6px' }}>
                {menu}
                <Divider style={{ margin: '3px 0 6px 0' }} />
                <Space
                  className="space-btn"
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  <Button
                    type="default"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.clearFilters?.()
                    }}
                  >
                    {t('重置')}
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.confirm()
                      setResourceLevelSelectOpen(false)
                    }}
                  >
                    {t('确定')}
                  </Button>
                </Space>
              </div>
            )}
            options={[
              { label: t('初级'), value: '1' },
              { label: t('中级'), value: '2' },
              { label: t('高级'), value: '3' },
            ]}
          />
        </div>
      ),

      filterIcon: (filtered: boolean) => (
        <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
          <FilterIcon type="icon-a-shaixuan1" $filtered={filtered} />
        </Tooltip>
      ),
    },
    {
      title: t('验证结果'),
      dataIndex: 'intercept_status',
      key: 'intercept_status',
      width: '7%',
      filteredValue: filterParams.intercept_status,
      filterDropdown: (props: FilterDropdownProps) => (
        <div style={{ padding: 8, width: 300 }}>
          <Select
            mode="multiple"
            allowClear
            maxTagCount={'responsive'}
            style={{ width: '100%' }}
            placeholder={t('请选择验证结果')}
            value={props.selectedKeys as string[]}
            open={interceptStatusSelectOpen}
            getPopupContainer={() => document.body as HTMLElement}
            dropdownClassName="table-filter-dropdown"
            onDropdownVisibleChange={setInterceptStatusSelectOpen}
            onChange={value => {
              props.setSelectedKeys(value)
            }}
            dropdownRender={menu => (
              <div style={{ marginBottom: '6px' }}>
                {menu}
                <Divider style={{ margin: '3px 0 6px 0' }} />
                <Space
                  className="space-btn"
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  <Button
                    type="default"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.clearFilters?.()
                    }}
                  >
                    {t('重置')}
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    style={{ letterSpacing: '-2px', padding: '0 12px' }}
                    onClick={() => {
                      props.confirm()
                      setInterceptStatusSelectOpen(false)
                    }}
                  >
                    {t('确定')}
                  </Button>
                </Space>
              </div>
            )}
            options={[
              { label: t('拦截成功'), value: '1' },
              { label: t('防护失效'), value: '2' },
              { label: t('检测成功'), value: '3' },
            ]}
          />
        </div>
      ),

      filterIcon: (filtered: boolean) => (
        <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
          <FilterIcon type="icon-a-shaixuan1" $filtered={filtered} />
        </Tooltip>
      ),

      render: (text: string) => (
        <div>
          <span className={interceptStatusMap[text]}>{text}</span>
        </div>
      ),
    },
    ...(deviceProtectionRanking?.length > 0
      ? [
          {
            title: t('设备结果分布'),
            dataIndex: 'device_status',
            key: 'device_status',
            width: '9%',
            filteredValue: filterParams.device_status,
            filterDropdown: (props: FilterDropdownProps) => (
              <div style={{ padding: 8, width: 300 }}>
                <Select
                  allowClear
                  mode="multiple"
                  maxTagCount={'responsive'}
                  style={{ width: '100%' }}
                  placeholder={t('请选择攻击类型')}
                  value={props.selectedKeys as string[]}
                  open={deviceStatusSelectOpen}
                  getPopupContainer={() => document.body as HTMLElement}
                  dropdownClassName="table-filter-dropdown"
                  onDropdownVisibleChange={setDeviceStatusSelectOpen}
                  onChange={value => {
                    props.setSelectedKeys(value)
                  }}
                  dropdownRender={menu => (
                    <div style={{ marginBottom: '6px' }}>
                      {menu}
                      <Divider style={{ margin: '3px 0 6px 0' }} />
                      <Space
                        className="space-btn"
                        style={{ display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <Button
                          type="default"
                          size="small"
                          style={{ letterSpacing: '-2px', padding: '0 12px' }}
                          onClick={() => {
                            props.clearFilters?.()
                          }}
                        >
                          {t('重置')}
                        </Button>
                        <Button
                          type="primary"
                          size="small"
                          style={{ letterSpacing: '-2px', padding: '0 12px' }}
                          onClick={() => {
                            props.confirm()
                            setDeviceStatusSelectOpen(false)
                          }}
                        >
                          {t('确定')}
                        </Button>
                      </Space>
                    </div>
                  )}
                  options={[
                    { value: 'ResourceDeviceStatusDetectSuccess', label: t('检测成功') },
                    { value: 'ResourceDeviceStatusInterceptSuccess', label: t('拦截成功') },
                    { value: 'ResourceDeviceStatusProtectionInvalid', label: t('防护失效') },
                    { value: 'ResourceDeviceStatusNotInvolved', label: t('不涉及') },
                  ]}
                />
              </div>
            ),

            filterIcon: (filtered: boolean) => (
              <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
                <FilterIcon type="icon-a-shaixuan1" $filtered={filtered} />
              </Tooltip>
            ),

            render: (_, record: any) => {
              const deviceStatusList: { name: string; count: number }[] = []
              const statusOrder = [
                { status: 'ResourceDeviceStatusDetectSuccess', name: t('检测成功') },
                { status: 'ResourceDeviceStatusInterceptSuccess', name: t('拦截成功') },
                { status: 'ResourceDeviceStatusProtectionInvalid', name: t('防护失效') },
                { status: 'ResourceDeviceStatusNotInvolved', name: t('不涉及') },
              ]

              // 无论text是否有数据，都确保返回4个状态
              statusOrder.forEach(orderItem => {
                const foundItem = record?.device_status_list?.find(
                  item => item.status === orderItem.status,
                )
                deviceStatusList.push({
                  name: orderItem.name,
                  count: foundItem ? foundItem.count : 0,
                })
              })

              return (
                <div>
                  {record?.device_status_list?.length === 1 &&
                  record.device_status_list[0]?.count === 1
                    ? statusOrder.find(
                        item => item.status === record?.device_status_list[0]?.status,
                      )?.name
                    : record?.device_status_list?.length > 0
                    ? deviceStatusList.map((item, index) => {
                        if (item.name === t('检测成功')) {
                          return (
                            <>
                              <Tooltip title={`检测成功${item.count}`}>
                                <span style={{ color: '#72B851' }} key={index}>
                                  {item.count}
                                </span>
                              </Tooltip>

                              <span style={{ margin: '0 4px' }}>|</span>
                            </>
                          )
                        } else if (item.name === t('拦截成功')) {
                          return (
                            <>
                              <Tooltip title={`拦截成功${item.count}`}>
                                <span style={{ color: '#5677D9' }} key={index}>
                                  {item.count}
                                </span>
                              </Tooltip>
                              <span style={{ margin: '0 4px' }}>|</span>
                            </>
                          )
                        } else if (item.name === t('防护失效')) {
                          return (
                            <>
                              <Tooltip title={`${t('防护失效')}${item.count}`}>
                                <span style={{ color: '#F44F4F' }} key={index}>
                                  {item.count}
                                </span>
                              </Tooltip>
                              <span style={{ margin: '0 4px' }}>|</span>
                            </>
                          )
                        } else {
                          return (
                            <>
                              <Tooltip title={`${t('不涉及')}${item.count}`}>
                                <span style={{ color: '#333333' }} key={index}>
                                  {item.count}
                                </span>
                              </Tooltip>
                            </>
                          )
                        }
                      })
                    : '-'}
                </div>
              )
            },
          },
        ]
      : []),
    {
      title: t('告警结果'),
      dataIndex: 'log_alarm',
      key: 'log_alarm',
      width: '7%',
      render: (text: number) => (
        <div>
          <span className={logAlarmMap[text].class}>{logAlarmMap[text].label}</span>
        </div>
      ),
    },
    {
      title: t('执行时间'),
      dataIndex: 'exec_time',
      key: 'exec_time',
      width: '14%',
      sorter: (a, b) => a.exec_time - b.exec_time,
      render: (text: string) => (
        <div>
          <span>{text ? text : '-'}</span>
        </div>
      ),
    },
    {
      title: t('操作'),
      fixed: 'right',
      width: '10%',
      render: (_, record: any) => (
        <div
          className="operation"
          onClick={() => {
            getDrawerData(record.id)
          }}
        >
          <IconFont type="icon-chakan" />
          <span>{t('查看')}</span>
        </div>
      ),
    },
  ]

  const rowSelection = {
    selectedRowKeys,
    onSelect: (record, selected) => {
      let newSelectedRowKeys = [...selectedRowKeys]
      if (selected) {
        newSelectedRowKeys.push(record.id)
      } else {
        newSelectedRowKeys = newSelectedRowKeys.filter(key => key !== record.id)
      }
      setSelectedRowKeys(newSelectedRowKeys)
    },
    onSelectAll: selected => {
      const newSelectedRowKeys = selected ? payloadList.map(item => item.id) : []
      setSelectedRowKeys(newSelectedRowKeys)
    },
  }

  const getDrawerData = taskPayloadId => {
    setDetailDrawerVisible(true)
    getPayloadDetail({
      task_payload_id: taskPayloadId,
    })
      .then(() => {})
      .catch(_ => {})
    getLogList({
      task_payload_id: taskPayloadId,
      result_id: id,
    }).catch(_ => {})
  }

  const handleToggleTime = (timeId: string) => {
    setTimeId(timeId)
    getEchartsData(timeId)
    refreshRequest(timeId)
  }

  // 返回上一页
  const handleBack = () => {
    navigate('/validation/network/waf?tab=task')
  }

  // 删除日志设备导入记录
  const deleteRecord = (importRecordId: string) => {
    deleteOfflineLogInfo({ resultId: id, id: importRecordId })
      .then(() => {
        refreshRequest()
        getEchartsData()
        setRandom(Math.random())
      })
      .catch(_ => {})
  }

  // 创建报表
  const createReport = values => {
    generateReport({
      task_list: [{ task_name: reportVisible.name, campaign_id: id }],
      ...values,
    })
      .then(() => {
        window.open('/report/task/task-report?tab=4', '_self')
      })
      .catch(_ => {})
  }

  // 删除任务
  const handleDelete = async () => {
    try {
      if (id) {
        await deleteTask({ ids: [id] })
        navigate('/validation/network/waf?tab=task')
      }
    } catch (error) {}
  }

  const handleExpand = () => {
    getExecuteTime({ result_id: id })
      .then(res => {
        setTimeId(res?.data?.execDate?.[0]?.id)
      })
      .catch(_ => {})
    getFailedCaseList({ resultId: id })
      .then(res => {
        setProgressContentList(res.data.payload || [])
      })
      .catch(_ => {})
    getUnsentCaseList({ resultId: id }).catch(_ => {})
  }

  const handleFixed = values => {
    setFixedModalVisible(false)
    const { interceptStatus } = values

    updateResourceInterceptStatus({
      id: id,
      list: {
        taskResultPayloadList: selectedRowKeys.map(id => ({
          payloadId: id,
          intercept_status: interceptStatus,
        })),
      },
    })
      .then(_ => {
        setRandom(new Date().getTime())
        form.resetFields()
        setSelectedRowKeys([])
        getPayloadList({ result_id: id, ...filterParams })
          .then(res => {
            // 安全处理返回数据，确保即使是空数据也能正确设置
            const items = res?.data?.items || []
            setPayloadList(items.map(item => item.overview))
            setPayloadTotal(res?.data?.total || 0)
            setFixPayloadCount(res?.data?.manual_correct_count || 0)
          })
          .catch(() => {
            // 请求失败时清空列表数据
            setPayloadList([])
            setPayloadTotal(0)
            setFixPayloadCount(0)
          })
      })
      .catch(_ => {})
  }

  const handleChecked = (e, cardId) => {
    let newSelectedRowKeys = [...selectedRowKeys]
    const selectedkey = e[0]
    if (!selectedkey) {
      newSelectedRowKeys = newSelectedRowKeys.filter(key => key !== cardId)
    } else {
      if (newSelectedRowKeys.includes(selectedkey)) {
        newSelectedRowKeys = newSelectedRowKeys.filter(key => key !== selectedkey)
      } else {
        newSelectedRowKeys.push(selectedkey)
      }
    }
    setSelectedRowKeys(newSelectedRowKeys)
  }

  const handleActive = (e, key) => {
    if (e.target.className === 'ant-checkbox-input') return
    getDrawerData(key)
    setCardActive(key)
  }

  const getEchartsData = (result_id: string | undefined = id) => {
    getTaskScore({ result_id, encode }).catch(_ => {})
    getVerifyResult({ resultId: result_id }).catch(_ => {})
    getDecodeRate({ result_id, encode }).catch(_ => {})
    getAttackProtectionRanking({ resultId: result_id }).catch(_ => {})
    getEncodeRate({ result_id, encode }).catch(_ => {})
    getRiskLevelDistribution({ resultId: result_id }).catch(_ => {})
    getCaseLevelDistribution({ resultId: result_id }).catch(_ => {})
    getDeviceProtectionRanking({ resultId: result_id }).catch(_ => {})
    getTemplateProtectionFailureRanking({ resultId: result_id }).catch(_ => {})
  }

  const refreshRequest = (result_id = id) => {
    getTaskInfo({ result_id })
      .then(res => {
        if (res.data.scheduler_type !== t('立即')) {
          getSerial({ result_id }).catch(_ => {})
          getExecuteType({ result_id }).catch(_ => {})
        }
      })
      .catch(_ => {})
    getProgressInfo({ result_id }).catch(_ => {})

    getAttackType({ resultId: result_id })
      .then(() => {
        setUpdateAttackType(true)
      })
      .catch(_ => {})
    getAttck({ result_id }).catch(_ => {})
    getResourceFilterData({ resultId: result_id }).catch(_ => {})
    getTemplateList({ result_id }).catch(_ => {})
    getComponents({ result_id }).catch(_ => {})
    getDevices({ result_id }).catch(_ => {})
    getTagTreeOptions({ result_id }).catch(_ => {})
    getOfflineLogInfo(result_id).catch(_ => {})

    setRandom(new Date().getTime())
    setFilterParams(prev => ({ ...prev, page: 1, limit: 20 }))
    getExecuteTime({ result_id: id })
      .then(res => {
        setTimeId(res?.data?.execDate?.[0]?.id)
      })
      .catch(_ => {})
    getFailedCaseList({ resultId: id })
      .then(res => {
        setProgressContentList(res.data.payload || [])
      })
      .catch(_ => {})
    getUnsentCaseList({ resultId: id }).catch(_ => {})
  }

  // 处理筛选参数，移除标识符
  const processFilterParams = (params: any) => {
    const processedParams = { ...params }
    const keyMapping = {
      tree_resource_level: 'resource_level',
      tree_risk_level: 'risk_level',
      tree_intercept_status: 'intercept_status',
      tree_device_ids: 'device_ids',
    }

    Object.keys(processedParams).forEach(key => {
      if (keyMapping[key]) {
        processedParams[keyMapping[key]] = processedParams[key]
        delete processedParams[key]
      }
    })

    return processedParams
  }

  const onTableChange = (pagination: any, filters: any, sorter: any) => {
    setFilterParams(prev => {
      // 保留之前的筛选条件，只更新发生变化的筛选条件
      const newFilters = { ...prev }

      // 处理表头筛选条件
      Object.keys(filters).forEach(key => {
        if (filters[key] === null) {
          delete newFilters[key]
        } else {
          newFilters[key] = filters[key]
        }
      })

      // 保留filterFormValue的筛选条件
      if (filterFormValue?.field && filterFormValue?.value) {
        const processedValue =
          filterFormValue.field === 'tag_ids'
            ? (filterFormValue.value as string[])?.map(item => item.split('$').slice(1).join('$'))
            : filterFormValue.value
        newFilters[filterFormValue.field] = processedValue
      }

      return {
        ...newFilters,
        page: pagination.current,
        limit: pagination.pageSize,
        sortOrder:
          sorter.order === 'descend'
            ? 'SORT_ORDER_DESCENDING'
            : sorter.order === 'ascend'
            ? 'SORT_ORDER_ASCENDING'
            : undefined,
      }
    })
  }

  const removeEncode = (e: boolean) => {
    setEncode(e ? 1 : 2)
  }

  useEffect(() => {
    getDeviceProtectionRanking({ resultId: id }).catch(_ => {})
    getOfflineLogInfo(id).catch(_ => {})
    getTaskInfo({ result_id: id })
      .then(res => {
        if (res.data.scheduler_type !== t('立即')) {
          getSerial({ result_id: id }).catch(_ => {})
          getExecuteType({ result_id: id }).catch(_ => {})
        }
      })
      .catch(_ => {})
    getProgressInfo({ result_id: id }).catch(_ => {})

    getAttackType({ resultId: id })
      .then(() => {
        setUpdateAttackType(true)
      })
      .catch(_ => {})
    getAttck({ result_id: id }).catch(_ => {})
    getResourceFilterData({ resultId: id }).catch(_ => {})
    getTemplateList({ result_id: id }).catch(_ => {})
    getComponents({ result_id: id }).catch(_ => {})
    getDevices({ result_id: id }).catch(_ => {})
    getTagTreeOptions({ result_id: id }).catch(_ => {})
  }, [])

  useEffect(() => {
    if (filterFormValue?.field) {
      const selectedOption = options.find(opt => opt.value === filterFormValue.field)
      console.log(filterFormValue, 'filterFormValue')
      if (selectedOption) {
        const processedValue =
          filterFormValue?.field === 'tag_ids'
            ? filterFormValue?.value === ''
              ? null
              : (filterFormValue?.value as string[])?.map(item =>
                  item.split('$').slice(1).join('$'),
                )
            : filterFormValue?.value === ''
            ? null
            : filterFormValue?.value
        setFilterParams(prev => {
          // 检查当前字段的值是否真的发生了变化
          if (prev[filterFormValue.field] === processedValue) {
            return prev
          }
          const dropdownKeys = options.map(opt => opt.value)
          const updatedParams = {
            ...prev,
            page: 1,
            [filterFormValue.field]: processedValue,
          }
          // 清除其他下拉筛选条件
          dropdownKeys.forEach(key => {
            if (key !== filterFormValue.field && key in updatedParams) {
              delete updatedParams[key]
            }
          })
          return updatedParams
        })
      }
    }
  }, [filterFormValue])

  useEffect(() => {
    // 在请求开始前先清空数据，避免显示旧数据
    setPayloadList([])
    setPayloadTotal(0)
    setFixPayloadCount(0)

    const processedParams = processFilterParams(filterParams)

    getPayloadList({ result_id: id, ...processedParams })
      .then(res => {
        // 安全处理返回数据，确保即使是空数据也能正确设置
        const items = res?.data?.items || []
        setPayloadList(items.map(item => item.overview))
        setPayloadTotal(res?.data?.total || 0)
        setFixPayloadCount(res?.data?.manual_correct_count || 0)
      })
      .catch(err => {
        // 请求失败时清空列表数据
        setPayloadList([])
        setPayloadTotal(0)
        setFixPayloadCount(0)
      })
  }, [filterParams])

  useEffect(() => {
    let intervalId
    if (importRecord.importing) {
      intervalId = setInterval(() => {
        getOfflineLogInfo(id)
          .then(res => {
            if (!res.data.importing) {
              refreshRequest()
              getEchartsData()
              setRandom(new Date().getTime())
            }
          })
          .catch(_ => {})
      }, 3000)
    }

    return () => clearInterval(intervalId)
  }, [importRecord])

  const statusMap = {
    2: { label: t('进行中'), color: '#2973FF', background: '#DBE8FF' },
    3: { label: t('已完成'), color: '#67c23a', background: '#E4F7D1' },
    4: { label: t('中断'), color: '#F53F3F', background: '#FFDCE0' },
    7: { label: t('停止中'), color: '#FF9900', background: '#FFEFD7' },
  }

  const fixedOptions = useMemo(
    () => [
      {
        label: t('拦截成功'),
        value: 'intercept_status_intercept_success',
      },
      {
        label: t('防护失效'),
        value: 'intercept_status_intercept_defence_fail',
      },
      ...(deviceProtectionRanking?.length > 0
        ? [
            {
              label: t('检测成功'),
              value: 'intercept_status_detect_success',
            },
          ]
        : []),
    ],

    [deviceProtectionRanking],
  )

  const taskContent = (
    <TaskContent>
      {taskInfoModel.map((item, index) => {
        const value =
          item.type && item.type !== 'array' && item.type !== 'object'
            ? taskInfo[item.value as string]
            : item.value
        if (value && typeof value === 'object') {
          // 处理进度信息渲染
          return (
            <div key={index} className="progress-info">
              <span className="label">{item.key}：</span>
              {value.map((v, i) => {
                if (v.value === 'progress') {
                  return (
                    <Progress
                      key={i}
                      strokeColor={{
                        '0%': '#ECEBF9',
                        '100%': '#5047CC',
                      }}
                      success={{ percent: -1 }}
                      percent={progressInfo[v.value as string]}
                    />
                  )
                } else {
                  return (
                    <div
                      key={i}
                      className={v.value}
                      style={
                        v.value === 'status'
                          ? {
                              background: statusMap[progressInfo?.[v.value as number]]?.background,
                              color: statusMap[progressInfo?.[v.value as number]]?.color,
                            }
                          : {}
                      }
                    >
                      {v.value === 'send_success' ? (
                        <Tooltip title={t('执行成功用例数量')}>
                          <span>{progressInfo?.[v.value as string]}</span>
                        </Tooltip>
                      ) : v.value === 'send_failed' ? (
                        <Tooltip title={t('执行失败用例数量')}>
                          <span>{progressInfo?.[v.value as string]}</span>
                        </Tooltip>
                      ) : (
                        <span>
                          {v.value === 'status'
                            ? statusMap[progressInfo?.[v.value as number]]?.label
                            : progressInfo?.[v.value as string]}
                        </span>
                      )}
                      {v.value === 'send_success' && (
                        <span style={{ color: '#666', margin: '0 4px' }}>/</span>
                      )}
                    </div>
                  )
                }
              })}
            </div>
          )
        } else {
          return (
            <div key={index}>
              <span className="label">{item.key}：</span>
              <span>{value}</span>
              <Divider type="vertical" />
            </div>
          )
        }
      })}
    </TaskContent>
  )

  const taskContentExpanded = (
    <TaskContentExpanded>
      {/* 任务信息 */}
      <div className="task-info">
        <div className="sub-title">
          <div>
            <SvgIcon width={16} height={16} name={'data-arrival'} fill={'#fff'} />
            <span className="text">{t('任务信息')}</span>
          </div>
          {[t('每日'), t('每月'), t('每周')].includes(taskInfo?.scheduler_type) && (
            <div style={{ fontSize: 13, fontWeight: 400, display: 'flex', alignItems: 'center' }}>
              <div>{t('执行日期：')} </div>
              <Select
                getPopupContainer={node => node?.parentNode?.parentNode}
                style={{ width: 180, marginRight: 10 }}
                value={timeId}
                onChange={dateId => {
                  handleToggleTime(dateId)
                }}
              >
                {executeTime?.map((item, index) => (
                  <Select.Option key={index} value={item.id}>
                    {item.time}
                  </Select.Option>
                ))}
              </Select>
              <div
                style={{
                  padding: '9px 4px',
                  background: '#ebeef7',
                  borderRadius: '4px',
                  color: '#666666',
                }}
              >
                {serial.serial}/{serial.count}
              </div>
            </div>
          )}
        </div>
        <div className="tab-box">
          <div className="left">
            <div className="tab-item active">
              <span>{t('验证模式1')}</span>
            </div>
            <div className="tab-item disabled">
              <span>{t('验证模式2')}</span>
            </div>
          </div>
          <div className="right">
            <div
              className={`tab-item ${infoActiveTab === 'taskTemplate' ? 'active' : ''}`}
              onClick={() => {
                setInfoActiveTab('taskTemplate')
              }}
            >
              <span>{t('任务模板')}</span>
            </div>
            <div
              className={`tab-item ${infoActiveTab === 'securityDevice' ? 'active' : ''}`}
              onClick={() => {
                setInfoActiveTab('securityDevice')
              }}
            >
              <span>{t('安全设备')}</span>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="left">
            {taskInfoExpanded.slice(0, taskInfoExpanded.length - 2).map((item, index) => {
              const value =
                item.type && item.type !== 'array' && item.type !== 'object'
                  ? taskInfo[item.value as string]
                  : item.value
              if (value && typeof value === 'object') {
                // 处理执行类型渲染
                if (taskInfo.scheduler_type === value[0].default) {
                  // 普通任务（立即执行）
                  return (
                    <div className="left-item" key={index}>
                      <span className="label">{item.key}：</span>
                      <span className="text" style={{ marginRight: 8 }}>
                        {value[0].default}
                      </span>
                      <span>
                        {executeTime &&
                          executeTime.length > 0 &&
                          executeTime.find(v => v.id === id)?.time}
                      </span>
                    </div>
                  )
                } else if (taskInfo?.scheduler_type?.includes(t('高频任务'))) {
                  return (
                    <div className="left-item" key={index}>
                      <span className="label">{item.key}：</span>
                      <span className="text">{taskInfo.scheduler_type}</span>
                    </div>
                  )
                } else {
                  // 定时任务
                  return (
                    <div className="left-item" key={index}>
                      <span className="label">{item.key}：</span>
                      <span className="text">{executeType?.type}</span>
                      {executeType?.time && (
                        <Select className="type-select" placeholder={t('点击查看')}>
                          {executeType?.time?.map((v, i) => (
                            <Select.Option key={i} value={v}>
                              {v}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </div>
                  )
                }
              } else {
                return (
                  <div key={index} className="left-item">
                    <span className="label">{item.key}：</span>
                    <span className="text">
                      {item.key === t('动态编码') ? (
                        taskInfo[value]?.length > 0 ? (
                          taskInfo[value]?.length > 2 ? (
                            <Tooltip
                              title={
                                <div>
                                  {taskInfo[value]?.map((v, i) => (
                                    <span key={v} style={{ display: 'block', marginBottom: '4px' }}>
                                      {v}
                                    </span>
                                  ))}
                                </div>
                              }
                            >
                              <div className="encode-items-wrapper">
                                {taskInfo[value].slice(0, 2).map(v => (
                                  <span className="encode-item" key={v}>
                                    {v}
                                  </span>
                                ))}
                                <span className="more-dots">...</span>
                              </div>
                            </Tooltip>
                          ) : (
                            <div className="encode-items-wrapper">
                              {taskInfo[value].map(v => (
                                <span className="encode-item" key={v}>
                                  {v}
                                </span>
                              ))}
                            </div>
                          )
                        ) : (
                          '-'
                        )
                      ) : item.key === t('执行速率') ? (
                        <span className="text">{value || value === 0 ? `${value}个/秒` : '-'}</span>
                      ) : item.deepType ? (
                        taskInfo[value]?.name || '-'
                      ) : item.key === t('配置名称') ? (
                        <span className="text">
                          {`${taskInfo.attackSource} → ${taskInfo.attackTarget}`}
                        </span>
                      ) : (
                        <Tooltip title={value || ''} placement="topLeft">
                          <span
                            style={{
                              width: 'calc(100% - 85px - 12px)',
                              minWidth: '190px',
                              display: 'inline-block',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {value || '-'}
                          </span>
                        </Tooltip>
                      )}
                    </span>
                  </div>
                )
              }
            })}
          </div>
          <div className="right">
            {infoActiveTab === 'taskTemplate' &&
              taskInfoExpanded
                .slice(taskInfoExpanded.length - 2, taskInfoExpanded.length - 1)
                .map((item, index) => (
                  <div className="tab-content">
                    {taskInfo[item.value as string]?.length > 0 ? (
                      taskInfo[item.value as string].map((v, i) => (
                        <Text key={i} className="template" ellipsis={{ tooltip: true }}>
                          {typeof v === 'object' ? `${v.device_brand}(${v.device_ip})` : v}
                        </Text>
                      ))
                    ) : (
                      <Empty image={EmptyImg} />
                    )}
                  </div>
                ))}
            {infoActiveTab === 'securityDevice' &&
              taskInfoExpanded
                .slice(taskInfoExpanded.length - 1, taskInfoExpanded.length)
                .map((item, index) => (
                  <div className="tab-content">
                    {taskInfo[item.value as string]?.length > 0 ? (
                      taskInfo[item.value as string].map((v, i) => (
                        <Text key={i} className="template" ellipsis={{ tooltip: true }}>
                          {typeof v === 'object'
                            ? `${v.device_type}-${v.device_name}-${v.device_ip}`
                            : v}
                        </Text>
                      ))
                    ) : (
                      <Empty image={EmptyImg} />
                    )}
                  </div>
                ))}
          </div>
        </div>
      </div>
      {/* 进度信息 */}
      <div className="progress-info">
        {/* payload 列表 */}
        <div style={{ display: !logInfo.visible && !failLogInfo.visible ? 'block' : 'none' }}>
          <div className="sub-title">
            <div className="left">
              <SvgIcon
                width={16}
                height={16}
                name={'task-detail-schedule'}
                fill={'#fff'}
                style={{ marginTop: '5px' }}
              />

              <span className="text" style={{ width: 65 }}>
                {t('执行信息')}
              </span>
            </div>
            <div className="create-time">
              <span>
                {t('执行时间：')}
                <span>{progressInfo?.start_time || progressInfo?.create_time}</span>
                <span style={{ margin: '0 4px' }}>{t('至')}</span>
                <span>{progressInfo?.end_time || '-'}</span>
              </span>
              <span style={{ marginLeft: 10 }}>
                {t('时长：')}
                <span style={{ marginLeft: 5 }}>
                  {t('共')}
                  {formatTimeInterval(
                    progressInfo?.start_time || progressInfo?.create_time,
                    progressInfo?.end_time,
                  )}
                </span>
              </span>
            </div>
          </div>
          <div
            style={{ display: 'flex', alignItems: 'center', margin: '15px 0', padding: '0 12px' }}
          >
            <div
              className="status"
              style={{
                background: statusMap[progressInfo.status]?.background,
                color: statusMap[progressInfo.status]?.color,
              }}
            >
              <span>{statusMap[progressInfo.status]?.label}</span>
            </div>
            <Progress
              className="progress"
              strokeColor={{
                '0%': '#ECEBF9',
                '100%': '#5047CC',
              }}
              success={{ percent: -1 }}
              percent={progressInfo?.progress}
            />
          </div>
          <div className="execute-box">
            <div className="execute-tab-box">
              <div className="execute-item-title">
                <div
                  className={
                    activeTab === 'failed'
                      ? 'execute-item-title-text active'
                      : 'execute-item-title-text'
                  }
                  onClick={() => {
                    setActiveTab('failed')
                    setProgressContentList(failedCaseList?.payload)
                  }}
                >
                  {t('执行失败（')}
                  {failedCaseList?.total || 0}）
                </div>
                <div
                  className={
                    activeTab === 'unexecuted'
                      ? 'execute-item-title-text active'
                      : 'execute-item-title-text'
                  }
                  onClick={() => {
                    setActiveTab('unexecuted')
                    setProgressContentList(unsentCaseList?.list)
                  }}
                >
                  {t('未执行（')}
                  {unsentCaseList?.total || 0}）
                </div>
              </div>
              <div className="execute-success-box">
                <span>{t('执行成功：')}</span>
                <span className="success-sum">{progressInfo?.send_success}</span>
                <span>{t('个')}</span>
              </div>
            </div>
            <div className="execute-tab-content">
              <ProgressContent
                setLogInfo={setLogInfo}
                type={activeTab === 'failed' ? 1 : 2}
                contentList={progressContentList}
              />
            </div>
          </div>
        </div>
        {/* payload 日志 */}
        <div style={{ display: logInfo.visible ? 'block' : 'none' }}>
          <div className="sub-title">
            <div className="left">
              <Button
                className="return-btn"
                icon={<IconFont type="icon-fanhui2" className="return-icon" />}
                onClick={() =>
                  setLogInfo(origin => ({ ...origin, visible: false, content: '', id: '' }))
                }
              />

              <span className="text">{t('执行日志：')}</span>
            </div>
          </div>
          <div className="log-content">
            <div className="log-panel">
              <div className="content">
                {logInfo.content && <div className="log-content">{logInfo.content}</div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </TaskContentExpanded>
  )

  const cardItem = item => (
    <div
      className={cardActive === item.id ? 'card-item active' : 'card-item'}
      key={item.id}
      onClick={e => handleActive(e, item.id)}
    >
      <div className="top">
        <Form form={form}>
          <Item noStyle name={item.id}>
            <Group
              options={[{ label: undefined, value: item.id }]}
              onChange={e => handleChecked(e, item.id)}
            />
          </Item>
        </Form>
        <Text
          style={{ width: '210px', marginLeft: '8px' }}
          ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
        >
          {item.name}
        </Text>
      </div>
      <div className="bottom">
        <div className="left">
          <SvgIcon
            name={item?.intercept_status === 1 ? 'protection_succeeded' : 'protection_failed'}
            width={'40px'}
            height={'44px'}
          />
        </div>
        <div className="right">
          <div
            className={
              item.intercept_status === t('拦截成功')
                ? 'intercept-status success'
                : 'intercept-status failed'
            }
          >
            {item.intercept_status}
          </div>
          <Text className="attack-type">{item.attack_type}</Text>
          <div className="icons">
            <div className={riskLevelMap[item.risk_level - 1].class}>
              {riskLevelMap[item.risk_level - 1].icon}
              <span>{riskLevelMap[item.risk_level - 1].label}</span>
            </div>
            <div className={logAlarmMap[item.log_alarm].class}>
              <span>{logAlarmMap[item.log_alarm].label}</span>
            </div>
            <div className={enctypeTypeMap[item.enctype_type]}>
              <span>{item.enctype_type}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <DetailContainer>
      {updateAttackType && (
        <DetailTemplate
          scene={displayModel.name}
          taskName={taskInfo.task_name}
          taskStatus={progressInfo.status}
          isImporting={importRecord.importing}
          taskContent={taskContent}
          taskContentExpanded={taskContentExpanded}
          canImport={importRecord.canImport}
          onTableChange={onTableChange}
          taskCharts={
            <TaskCharts
              taskScore={taskScore}
              verifyResult={verifyResult}
              decodeRate={decodeRate}
              attackProtectionRanking={attackProtectionRanking}
              deviceProtectionRanking={deviceProtectionRanking}
              templateProtectionFailureRanking={templateProtectionFailureRanking}
              encodeRate={encodeRate}
              riskLevelDistribution={riskLevelDistribution}
              caseLevelDistribution={caseLevelDistribution}
            />
          }
          treeData={tagTreeData}
          cardItem={cardItem}
          handleExpand={handleExpand}
          filterOptions={options}
          filterFormValue={filterFormValue}
          setFilterFormValue={setFilterFormValue}
          filterParams={filterParams}
          setFilterParams={setFilterParams}
          columns={columns}
          scroll={{ x: 1300 }}
          dataSource={payloadList}
          total={payloadTotal}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          rowSelection={rowSelection}
          fixedCount={fixPayloadCount}
          fixedOptions={fixedOptions}
          handleFixed={handleFixed}
          fixedLoading={updateInterceptStatusLoading}
          getEchartsData={getEchartsData}
          removeEncode={removeEncode}
          refreshRequest={refreshRequest}
          encode={encode}
          loading={loading}
          handleBack={handleBack}
          openRecordModal={setRecordVisible}
          openImportModal={setImportVisible}
          openReportModal={setReportVisible}
          openDeleteModal={setDeleteVisible}
          fixedModalVisible={fixedModalVisible}
          setFixedModalVisible={setFixedModalVisible}
        />
      )}
      <RecordModal
        open={recordVisible}
        loading={deleteRecordLoading}
        dataSource={importRecord.logDeviceRecords}
        onClose={() => setRecordVisible(false)}
        handleDelete={deleteRecord}
      />

      <ImportModal
        open={importVisible}
        type={'WS'}
        resultId={id}
        refreshPage={() => {
          refreshRequest()
          getEchartsData()
          setRandom(Math.random())
        }}
        onClose={() => setImportVisible(false)}
        options={[
          { label: 'WAF', value: 'WAF', disabled: false },
          { label: 'NTA', value: 'NTA', disabled: true },
          { label: 'IDS', value: 'IDS', disabled: true },
          { label: 'IPS', value: 'IPS', disabled: true },
        ]}
      />

      <CreateReport
        visible={reportVisible.visible}
        createLoading={createLoading}
        templateType={4}
        onConfirm={e => {
          createReport(e)
        }}
        onCancel={() => {
          setReportVisible(origin => ({ ...origin, visible: false }))
        }}
      />

      <DeleteModal
        onOk={handleDelete}
        visible={deleteVisible}
        title={<BasTitle title={t('删除任务')} />}
        text={t('此操作将永久删除该任务,是否继续?')}
        onCancel={() => {
          setDeleteVisible(false)
        }}
      />

      <DetailDrawer
        onClose={() => {
          setDetailDrawerVisible(false)
        }}
        dataList={dataList}
        logList={logList}
        visible={detailDrawerVisible}
        loading={detailLoading}
      />
    </DetailContainer>
  )
}

export default Detail

const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-bottom: 16px;
  height: 100%;
  .case_name {
    &:hover {
      text-decoration: underline;
    }
  }
`

const TaskContent = styled.div`
  display: flex;
  align-items: center;

  .label {
    color: #86909c;
    margin-right: 4px;
    flex-shrink: 0;
  }

  .ant-divider-vertical {
    margin: 0 19px;
  }

  .progress-info {
    flex: 1;
    display: flex;
    height: 100%;
    width: 50%;

    .status {
      width: 50px;
      height: 18px;
      border-radius: 9px;
      font-size: 12px;
      text-align: center;
      line-height: 18px;
      flex-shrink: 0;
      margin-right: 10px;
    }

    .ant-progress-line {
      font-size: 12px;
      width: 90%;
      margin-right: 20px;
    }

    .send_success {
      color: #3586ff;
      font-size: 12px;
      flex-shrink: 0;
    }

    .send_failed {
      color: #f5222d;
      font-size: 12px;
      flex-shrink: 0;
    }
  }
`

const TaskContentExpanded = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .ant-progress-outer {
    margin-right: calc(-2em - 17px);
    padding-right: calc(2em + 17px);
  }

  .task-info {
    flex: 1;
    height: 100%;
    border: 1px solid #e1e3e4;
    margin-right: 16px;
    border-radius: 8px;
    width: 50%;

    .sub-title {
      height: 35px;
      display: flex;
      align-items: center;
      padding-left: 6px;
      justify-content: space-between;

      .text {
        margin-left: 10px;
        font-weight: 500;
        font-size: 16px;
      }
    }
    .tab-box {
      width: 100%;
      height: 32px;
      display: flex;
      align-items: center;
      .left {
        width: 50%;
        min-width: 325px;
        height: 100%;
        display: flex;
        align-items: center;
        border-right: 1px solid #e1e3e4;
      }
      .right {
        width: 50%;
        min-width: 325px;
        height: 100%;
        display: flex;
        align-items: center;
      }
      .tab-item {
        width: 84px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &.active {
          color: #4238c9;
          background: #e3e1f5;
        }
        &.disabled {
          color: #333333;
          cursor: not-allowed;
        }
      }
    }

    .content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        height: 100%;
        font-size: 12px;
        width: 50%;
        border-right: 1px solid #e1e3e4;
        padding-left: 12px;
        padding-top: 12px;

        .left-item {
          margin-bottom: 10px;
          display: flex;
          align-items: center;

          .encode-items-wrapper {
            display: flex;
            flex-wrap: wrap;
            gap: 4px;
            align-items: center;
          }

          .encode-item {
            display: inline-block;
            padding: 2px 4px;
            background: #f0f0f0;
            border-radius: 4px;
            font-size: 12px;
          }

          .more-dots {
            color: #666;
            margin-left: 2px;
          }

          .label {
            width: 85px;
            flex-shrink: 0;
            color: #86909c;
            font-size: 12px;
          }
          .text {
            font-size: 12px;
          }
        }
      }

      .right {
        width: 50%;
        height: 262px;
        padding-top: 12px;
        .tab-content {
          padding: 0 12px;
          overflow-y: scroll;
          height: 100%;
          .template {
            width: 100%;
            font-size: 13px;
            line-height: 18px;
            margin-bottom: 10px;
          }
        }
        .ant-tabs {
          border-radius: 6px;

          .ant-tabs-nav {
            padding: 0 12px;
            background: #f1f3f5;
            margin-bottom: 8px;

            .ant-tabs-tab {
              color: #86909c;
            }

            .ant-tabs-tab.ant-tabs-tab-active {
              color: #4238c9;
            }
          }

          .tab-content {
            padding: 0 12px;
            overflow-y: scroll;
            max-height: 170px;
            max-width: 256px;

            .template {
              width: 100%;
              font-size: 12px;
              line-height: 18px;
            }
          }
        }
      }
    }
  }

  .progress-info {
    flex: 1;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #e1e3e4;
    width: 50%;

    .status {
      width: 50px;
      height: 18px;
      border-radius: 9px;
      font-size: 12px;
      text-align: center;
      line-height: 18px;
      flex-shrink: 0;
      margin-right: 10px;
    }

    .execute-box {
      min-height: 246px;

      .execute-tab-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 12px;
        .execute-item-title {
          height: 32px;
          background: #eeeff1;
          display: flex;
          align-items: center;
          .execute-item-title-text {
            font-size: 14px;
            color: #333;
            height: 100%;
            padding: 0 12px;
            display: flex;
            align-items: center;
            cursor: pointer;
          }
          .active {
            color: #4238c9;
            background: #e3e1f5;
          }
        }
        .execute-success-box {
          .success-sum {
            color: #67c23a;
          }
        }
      }
      .execute-tab-content {
        margin-top: 14px;
      }
    }

    .sub-title {
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e1e3e4;
      padding: 0 12px;

      .left {
        display: flex;

        .return-btn {
          width: 24px;
          height: 24px;
          display: flex;
          justify-content: center;
          justify-items: center;
          align-items: center;
          margin-right: 12px;
          background: #fff;
          border: 0px;

          &:hover {
            border: 1px solid #4238c9;
            color: #4238c9;
          }
        }

        .return-icon {
          font-size: 12px;
        }

        .text {
          margin-left: 10px;
          font-weight: 500;
          font-size: 16px;
          margin-right: 6px;
          line-height: 24px;
        }

        .status {
          width: 50px;
          height: 18px;
          border-radius: 9px;
          font-size: 12px;
          text-align: center;
          line-height: 18px;
          flex-shrink: 0;
          margin-right: 10px;
        }
      }

      .create-time {
        color: '#666';
      }
    }

    .log-content {
      height: 283px;

      .log-panel {
        border-radius: 8px;
        height: 235px;
        display: flex;
        flex-direction: column;

        .header {
          height: 36px;
          border-radius: 8px 8px 0 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 16px;

          .left {
            height: 100%;
            display: flex;
            padding-top: 10px;

            span:first-child {
              width: 14px;
              height: 14px;
              background: #ff5f56;
              border-radius: 50%;
            }

            span:nth-child(2) {
              width: 14px;
              height: 14px;
              background: #ffbb2f;
              border-radius: 50%;
              margin: 0 8px;
            }

            span:last-child {
              width: 14px;
              height: 14px;
              background: #27c841;
              border-radius: 50%;
            }
          }

          .copy-btn .ant-typography .copy {
            color: #d0d0d0;

            &:hover {
              color: #fff;
            }
          }
        }

        .content {
          flex: 1;
          border-radius: 0 0 8px 8px;
          padding: 14px 12px;
          overflow-y: scroll;
          display: flex;
          flex-direction: column;

          span {
            color: #fff;
            line-height: 20px;
          }
        }
      }
    }

    .information {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 8px;
      color: #666;
      font-size: 12px;

      .success-sum {
        color: #73a0fa;
      }

      .failed-sum {
        color: #f44f4f;

        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }
`

const FilterIcon = styled(IconFont)<{ $filtered?: boolean }>`
  font-size: 14px;
  color: ${props => (props.$filtered ? '#4238C9' : '#999')};
  cursor: pointer;
  transition: color 0.3s;
  &:hover {
    color: #4238c9;
  }
`
